import { EEnvironment } from "./app.config.types";
export var CONFIG_STAG = {
    // Main
    ENVIRONMENT: EEnvironment.Stag,
    // Rentio API
    BASE_URL: "https://api.staging.rentio.be/v1",
    // BASE_URL: "http://localhost:3100/v1",
    BASE_URL_V2: "https://api-next.stag.rentio.be/v2",
    // BASE_URL_V2: "http://localhost:3000/v2",
    BASE_URL_SERVERLESS: "https://serverless.staging.rentio.be",
    URL_SOCKETS: "wss://api.staging.rentio.be/v1/websocket?access_token={{accessToken}}&locale={{locale}}",
    // Google
    CAPTCHA_KEY: 
    // cspell:disable-next-line
    "6LcxNJokAAAAAO7A3tB4AGgq8GI-_4TXjjy0Bpuy",
    // Pay
    PAYMENT_LIMIT_AMOUNT_MESSAGE_DELAY: 3000,
    // Partners
    INSURANCE_TENANT_FLOW_URL: "https://dev.rentio-insurance.be",
    KEYPOINT_REPAIR_URL: "https://uat-case.keypoint.be",
};
